// src/components/ServiceResquests/Modal/index.tsx
import {FC, ReactNode} from 'react'
import {BaseModal} from '../../Modals/BaseModal/BaseModal'

type Props = {
  onCloseAction: () => void
  title: string
  width?: string
  disableClose?: boolean
  editPageProduct?: boolean
  showAlert?: boolean
  children?: ReactNode
  hasFixedFooter?: boolean
}

export const ServiceRequestModal: FC<Props> = ({
  onCloseAction,
  title,
  width,
  disableClose,
  showAlert,
  children,
  hasFixedFooter = false,
}) => {
  return (
    <BaseModal
      title={title}
      onCloseAction={onCloseAction}
      width={width}
      disableClose={disableClose}
      showAlert={showAlert}
      editPageProduct={true} // sempre true para remover padding e overflow
    >
      <div style={{position: 'relative', height: hasFixedFooter ? '89vh' : 'auto'}}>{children}</div>
    </BaseModal>
  )
}
